import { Col } from "react-bootstrap"
import styled from "styled-components"

export const StyledIssueCampaignList = styled(Col)`
    padding: 0px;
`
